/**
 * User Service
 * API calls for user management
 */

import { apiConfig } from '../config/api';
import { AuthService } from './authService';

const BASE_URL = apiConfig.brandsApi; // Using brands API base URL

export interface User {
  id: string;
  email: string;
  name: string;
}

export class UserService {
  /**
   * Get authentication headers with Supabase token
   */
  private static async getHeaders(): Promise<HeadersInit> {
    const token = await AuthService.getToken();
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  }

  /**
   * Get all users (Admin only)
   */
  static async getAllUsers(): Promise<User[]> {
    try {
      const headers = await this.getHeaders();
      const response = await fetch(`${BASE_URL}/api/v1/users`, {
        method: 'GET',
        headers,
        credentials: 'include',
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success || !data.data || !data.data.users) {
        throw new Error('Invalid API response');
      }

      return data.data.users;
    } catch (error) {
      console.error('Failed to fetch users:', error);
      throw error;
    }
  }
}

